import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../assets/background.png";

import MTCGameResult from "./MTCGameResultLimited";
import LoadingScreen from "./LoadingScreen";
import { Button } from "../../../globals/components/button";
import { Scale } from 'react-scaling';



export default function MTC({ ...props }) {
  const [remainingTime, setRemainingTime] = useState(
    props.defaultTimer ? props.defaultTimer : 30
  );
  const [showFeedback, setShowFeedback] = useState(false);
  //const [questionsAnswered, setQuestionsAnswered] = useState(
  //  props.questionsAnswered ? props.questionsAnswered : 0
  //);
  //
  useEffect(() => {
    if (remainingTime > 0) {
      //console.log(questionsAnswered)
      var timerID = setInterval(() => decrementTimer(), 1000);
      return () => {
        clearInterval(timerID);
      };
    }
  }, [remainingTime]);

  function decrementTimer() {
    setRemainingTime(remainingTime - 1);
  }

  function restartGame() {
    console.log("restart");
    props.restart();
    
    setRemainingTime(props.defaultTimer ? props.defaultTimer : 30);
  }

  const {
    children,
    correct,
    incorrect,
    score,
    onBack,
    quitGame,
    loading,
    feedback,
    questionFontSize,
    questionsAnswered,
    questionCount
  } = props;

  console.log(props.questionCount);
  console.log(props.questionsAnswered);
  console.log(props.hidescore);

  return (
    <ApplicationContainer style={{background:props.bgcolor}}>
      <Scale scaleTo={1720}>
        <ApplicationHeader>
          <LeftHeader>
            {questionsAnswered >= props.questionCount || props.hidescore != undefined ? (
              <div></div>
            ) : (
                <Score>{questionsAnswered}/25</Score>
              )}

          </LeftHeader>
          <CenterHeader>
          </CenterHeader>
          <RightHeader>

            <Back onClick={onBack}>Back</Back>
          </RightHeader>
        </ApplicationHeader>
        {questionsAnswered < props.questionCount && !loading ? ( //THIS USED TO BE remaining time > 0 && !loading
          children
        ) : loading ? (
          <LoadingScreen />
        ) : (
              console.log("tst: here!"),
              <MTCGameResult
              
                feedback={feedback}
                questionFontSize={questionFontSize}
                score={score}
                correct={correct}
                incorrect={incorrect}
                onRestartGame={() => restartGame()}
                onBack={onBack}
                quitGame={quitGame}
                isRating={false}
              />
            )}
      </Scale>

    </ApplicationContainer>

  );
}

const ApplicationContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: #fff;
`;

const ApplicationHeader = styled.div`
  width: 100%;
  height: 60px;
  background: #683d8c;
  justify-content: space-around;
  display: flex;
`;

const LeftHeader = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
`;

const RightHeader = styled.div`
  width: 30%;
  display: flex;
`;

const CenterHeader = styled.div`
  width: 30%;
  display: flex;
  justify-content: center;
`;

const Timer = styled.div`
  width: 200px;
  height: 80px;
  background: #ef3e37;
  text-align: center;
  font-size: 3em;
  font-weight: 600;
  color: #fff;
  line-height: 80px;
  margin-top: 0px;
  border-radius: 0px 0px 15px 15px;
  z-index: 11;
`;

const ApplicationBody = styled.div`
  width: 100%;
  height: 100%;
  background: #2a64a4;
  background-image: url(${background});
  background-size: cover;
  background-position: 0px -1px;
`;

const ApplicationResult = styled.div`
  height: 100%;
  z-index: 10;
  background: #fff;
  background-image: url(${background});
  padding: 150px;
  font-size: 3em;
  border: solid 2px #683d8c;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const IncorrectCount = styled.div`
  margin-top: 10px;
  width: 50px;
  height: 40px;
  background: #ef3e37;
  text-align: center;
  font-size: 2em;
  font-weight: 600;
  line-height: 40px;
  color: #fff;
  border-radius: 5px;
`;

const CorrectCount = styled.div`
  width: 50px;
  height: 40px;
  margin-top: 10px;
  background: #42b231;
  text-align: center;
  font-size: 2em;
  font-weight: 600;
  line-height: 40px;
  color: #fff;
  margin-left: 20px;
  border-radius: 5px;
`;

const Score = styled.div`
  width: 150px;
  height: 40px;
  margin-top: 10px;
  background: #4b2e6b;
  text-align: center;
  font-size: 2em;
  font-weight: 600;
  line-height: 40px;
  color: #fff;
  margin-left: 20px;
  border-radius: 20px;
`;

const Back = styled.div`
  width: 150px;
  height: 40px;
  margin-top: 10px;
  background: #4b2e6b;
  user-select: none;
  text-align: center;
  font-size: 2em;
  font-weight: 600;
  line-height: 40px;
  color: #fff;
  margin-left: 20px;
  border-radius: 20px;
  &:hover {
    cursor: pointer;
  }
`;

const ResultScores = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  flex-direction: column;
`;

const Result = styled.div`
  display: flex;
`;
const ResultValue = styled.div`
  margin: 0px 20px;
  border: solid #e4e4e4 2px;
  background: #fff;
  padding: 0px 15px;
`;

const Banner = styled.div`
  position: absolute;
  left: 50%;
  display: block;
  margin: 100px -200px;
  width: 400px;
  height: 60px;
  border: 1px solid #e88f12;
  font: normal 30px/60px;
  line-height: 60px;
  font-weight: 600;
  text-align: center;
  color: #fff;
  background: rgba(255, 186, 32, 1);
  border-radius: 4px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.15) inset, 0 6px 10px rgba(0, 0, 0, 0.15);
  &::before,
  ::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: -70px;
    top: 24px;
    display: block;
    width: 40px;
    height: 0px;
    border: 30px solid #e88f12;
    border-right: 20px solid #c97e11;
    border-bottom-color: #e88f12;
    border-left-color: transparent;
    transform: rotate(-5deg);
  }

  &::after {
    left: auto;
    right: -70px;
    border-left: 20px solid #c97e11;
    border-right: 30px solid transparent;
    transform: rotate(5deg);
  }
`;
